import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { requestGetDeliveryCompanies } from "./getDeliveryCompanies.request";
import {
  GetDeliveryCompaniesRequestParams,
  GetDeliveryCompaniesResponse
} from "./getDeliveryCompanies.types";

export const DELIVERY_COMPANIES_QUERY_KEY = "delivery-companies";

const useGetDeliveryCompanies = (
  params: GetDeliveryCompaniesRequestParams,
  options?: QueryOptions<
    GetDeliveryCompaniesResponse,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: [DELIVERY_COMPANIES_QUERY_KEY, "admin", "all", params],
    queryFn: async () => await requestGetDeliveryCompanies(params),
    ...options
  });

  return { companies: data?.data, meta: data?.meta, ...rest };
};

export default useGetDeliveryCompanies;
